import React from "react";
import ApiCommunityDirectoryPage from "./ApiCommunityDirectoryPage";

export default function Senegalese() {
  return (
    <ApiCommunityDirectoryPage
      community="Senegalese"
      eyebrow="Senegalese community guide"
      title="Senegalese favorites, businesses, and local essentials in San Antonio."
      
      tags={["Senegalese community", "San Antonio", "Local businesses"]}
      claimText="Want your business featured in the Senegalese community guide?"
      modalIdPrefix="senegalese-directory"
    />
  );
}
